'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PaymentRequestButtonElement = {};

exports.__exports = PaymentRequestButtonElement;
